// extracted by mini-css-extract-plugin
module.exports = {"reactions":"Reactions_reactions__ANgrf","reaction":"Reactions_reaction__vDUHd","you":"Reactions_you__IPhsg"};